import { SEO_TEXT, type SeoPageId } from "@clinic/shared";
import { useEffect } from "react";
import { useT } from "./i18n";

/**
 * Sets the page title and description while navigating inside the app. The first page
 * load already gets both from the API (apps/api/src/http/seo.ts), from the same texts.
 */
export function usePageMeta(page: Exclude<SeoPageId, "book">): void;
export function usePageMeta(
  page: "book",
  clinic: { name: string; address: string; description: string } | undefined,
): void;
export function usePageMeta(page: SeoPageId, clinic?: { name: string; address: string; description: string }) {
  const { locale } = useT();
  useEffect(() => {
    const texts = SEO_TEXT[locale];
    const meta = page === "book" ? (clinic ? texts.book(clinic) : null) : texts[page];
    if (!meta) return;
    document.title = meta.title;
    if (meta.description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", meta.description);
    }
  }, [locale, page, clinic]);
}
